import { Button } from '@/components/ui';
import { Link } from 'react-router-dom';
import routes from '@/lib/routes';
import { ReactNode } from 'react';

type TProps = {
  userId: string;
  text?: ReactNode;
}

export const ButtonLinkUser = ({ userId, text = `l'utilisateur` }: TProps) => (
  <Link to={routes.nav.users.single.getHref(userId)}>
    <Button
      type='button'
      variant={'link'}
      className='text-purple-600 h-0 mx-0 px-0'>
      {text}
    </Button>
  </Link>
);

export default ButtonLinkUser;
